import React from 'react';
import { BaseCrud } from 'react/containers/layout/Crud';
import { TextField, LookupField } from 'react/components/fields';

const TicketCrud = (props) => (
  <BaseCrud updateMethod="PATCH" tabName="Ticket.title" {...props}>
    <TextField
      label="Ticket.field.key"
      name="key"
      shouldShow={false}
    />
    <TextField
      label="Ticket.field.title"
      name="title"
      shouldShow={false}
    />
    <TextField
      label="Ticket.field.created"
      name="created"
      shouldShow={false}
      gridFormatter={() => ({
        id: 'created',
        name: 'created',
        label: 'Ticket.field.created',
        type: 'DATE_TIME'
      })}
    />
    <TextField
      label="Ticket.field.dueDate"
      name="dueDate"
      shouldShow={false}
      gridFormatter={() => ({
        id: 'dueDate',
        name: 'dueDate',
        label: 'Ticket.field.dueDate',
        type: 'DATE_TIME'
      })}
    />
    <TextField
      label="Ticket.field.modified"
      name="modified"
      shouldShow={false}
      gridFormatter={() => ({
        id: 'modified',
        name: 'modified',
        label: 'Ticket.field.modified',
        type: 'DATE_TIME'
      })}
    />
    <TextField
      label="Ticket.field.whenStatusChanged"
      name="whenStatusChanged"
      shouldShow={false}
      gridFormatter={() => ({
        id: 'whenStatusChanged',
        name: 'whenStatusChanged',
        label: 'Ticket.field.whenStatusChanged',
        type: 'DATE_TIME'
      })}
    />

    <TextField
      label="Ticket.field.ticketStatus"
      name="ticketStatus"
      shouldShow={false}
      gridFormatter={() => ({
        id: 'ticketStatus',
        name: 'ticketStatus',
        label: 'Ticket.field.ticketStatus',
        type: 'PICKLIST_MULTISELECT_FILTER',
        isAReactField: true,
        fieldDomains: [
          { value: 'OPEN', description: 'Ticket.field.ticketStatus.Open' },
          { value: 'ASSIGNED', description: 'Ticket.field.ticketStatus.Assigned' },
          { value: 'WAITING_SERVICE', description: 'Ticket.field.ticketStatus.WaitingService' },
          { value: 'RE_ASSIGNED', description: 'Ticket.field.ticketStatus.Reassigned' },
          { value: 'CLOSED', description: 'Ticket.field.ticketStatus.Closed' },
          { value: 'REOPENED', description: 'Ticket.field.ticketStatus.Reopened' }
        ]
      })}
    />

    <LookupField
      label="Ticket.field.ticketType"
      name="ticketType"
      lookupEntity="TicketType"
      lookupEntityColumn="description"
      shouldShow={false}
    />
    <LookupField
      label="Ticket.field.ticketResolution"
      name="ticketResolution"
      lookupEntity="TicketResolution"
      lookupEntityColumn="description"
      shouldShow={false}
    />
    <LookupField
      label="Ticket.field.userCreated"
      name="userCreated"
      lookupEntity="Users"
      lookupEntityColumn="name"
      shouldShow={false}
    />
    <LookupField
      label="Ticket.field.userModified"
      name="userModified"
      lookupEntity="Users"
      lookupEntityColumn="name"
      shouldShow={false}
    />
    <LookupField
      label="Ticket.field.userAssigned"
      name="userAssigned"
      lookupEntity="Users"
      lookupEntityColumn="name"
      shouldShow={false}
    />
    <LookupField
      label="Ticket.field.lastUserChangedStatus"
      name="lastUserChangedStatus"
      lookupEntity="Users"
      lookupEntityColumn="name"
      shouldShow={false}
    />
  </BaseCrud>
);

export default TicketCrud;
